import { Button, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import withReducer from 'app/store/withReducer';
import classNames from 'classnames';
import React from 'react';
import { HiOutlineRefresh } from 'react-icons/hi';
import { IoMdDownload } from 'react-icons/io';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/PWAActions';
import reducer from './Store/Reducers/PWAReducer';

const styles = theme => ({
    button: {
        margin: '5px',
        color: '#fff'
    },
    toolbar: {
        background: theme.palette.primary.main,
        color: theme.palette.type === 'dark' ? '#FFFFFF' : '#494949',
    }
});

class PWAApp extends XAPPComponent {

    componentDidMount() {
        window.addEventListener('beforeinstallprompt', e => {
            e.preventDefault()
            this.props.setEvent(e)
        })
    }

    onClickInstall = () => {
        this.props.proposalEvent.prompt();
    }

    render() {
        const { proposalEvent, classes } = this.props;
        return (
            <React.Fragment>
                <div className={classNames(classes.toolbar, "flex")}>
                    {proposalEvent === null &&
                        <div className="flex-1" />
                    }
                    <Button
                        className={classNames(classes.button, "")}
                        onClick={() => {
                            navigator.serviceWorker.register('/service-worker.js').then(reg => {
                                // sometime later…
                                reg.update();
                            });
                            window.sessionStorage.clear();
                            document.location.reload(true);
                        }}
                    >
                        <HiOutlineRefresh className="mr-8 text-20 text-white" />
                        ATUALIZAR
                    </Button>
                    {/* {proposalEvent !== null &&
                        <React.Fragment>
                            <div className="flex-1" />
                            <Button
                                className={classNames(classes.button, "")}
                                onClick={() => this.onClickInstall()}
                            >
                                <IoMdDownload className="mr-8 text-20 text-white" />
                                INSTALAR
                            </Button>
                        </React.Fragment>
                    } */}
                </div>
            </React.Fragment>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setEvent: Actions.setEvent,
    }, dispatch);
}

function mapStateToProps({ PWAApp }) {
    return {
        proposalEvent: PWAApp.proposalEvent,
    }
}

export default withStyles(styles, { withTheme: false })(withReducer('PWAApp', reducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(PWAApp))));
